import {apiFetch,showAppAlert} from '../api';
function emit(url,state,error=''){window.dispatchEvent(new CustomEvent('dispoboard:resource-read',{detail:{path:new URL(url,window.location.origin).pathname,state,error}}));}
export async function resourceFetch(url,options) {
 const read=!options?.method||options.method==='GET';
 if(read)emit(url,'loading');
 try{
 const response=await apiFetch(url,options);
 if(!response.ok){const data=await response.clone().json().catch(()=>({}));throw new Error(data.error||`Anfrage fehlgeschlagen (${response.status})`);}
 if(read)emit(url,'ready');else window.dispatchEvent(new CustomEvent('dispoboard:toast',{detail:{message:options.method==='DELETE'?'Eintrag gelöscht':'Änderungen gespeichert'}}));
 return response;
 }catch(error){if(read){emit(url,'error',error.message);error.resourceRead=true;}throw error;}
}
export function reportResourceError(error){if(!error.resourceRead)showAppAlert(error.message,{title:'Aktion fehlgeschlagen',danger:true});}
